var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"error-messages":_vm.errors,"items":_vm.items,"label":"Edad del grupo","clearable":"","dense":"","outlined":""},on:{"input":function($event){return _vm.$emit('input', _vm.selected)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }